import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Translate } from "react-redux-i18n";

class PlanCallAction extends Component {
  render() {
    return (
      <div className="adnew-plan-cta">
        <h4 className="adnew-plan-cta__title">
          ¡<Translate value="suggestion" />!
        </h4>
        <p className="adnew-plan-cta__text">
          <Translate value="plan_suggestion" />
        </p>
        <Link to="/mysuscription" className="adnew-plan-cta__link">
          <Translate value="register_tip11" />
        </Link>
      </div>
    );
  }
}

export default PlanCallAction;
